import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { LODGING_DOORS_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/LodgingDoors/LodgingDoorsColumnsInfo'
import { HOTEL_AMENITIES } from 'constants/hotelAmenities'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { buildTargetExportModal } from './TargetExportModal'

const lodgingColumnHelper = createExportColumnHelper({
  columns: LODGING_DOORS_COLUMNS,
})

export default buildTargetExportModal({
  targetType: 'lodging',
  isDoors: true,
  title: 'Select Columns for Lodging & Hospitality Doors Download',
  subTitle:
    'Download up to 10,000 lodging & hospitality doors at a time, with any of the following columns. Any filters already applied will remain active.',
  submitText: 'Export Lodging & Hospitality Doors',
  progressName: 'Exporting Lodging & Hospitality Doors...',
  downloadLabel: 'Lodging Companies',
  useColumnGroups: () => {
    const { enableLodgingHotelAmenities } = useFeatureFlagService()
    return [
      {
        title: 'Target Attributes',
        elements: [
          lodgingColumnHelper.retrieveColumn('name'),
          lodgingColumnHelper.retrieveColumn('chain_id'),
          lodgingColumnHelper.retrieveColumn('address'),
          lodgingColumnHelper.retrieveColumn('city'),
          lodgingColumnHelper.retrieveColumn('state'),
          lodgingColumnHelper.retrieveColumn('country'),
          lodgingColumnHelper.retrieveColumn('phone'),
          lodgingColumnHelper.retrieveColumn('website'),
          lodgingColumnHelper.retrieveColumn('reviews_avg'),
          lodgingColumnHelper.retrieveColumn('reviews_cnt'),
          lodgingColumnHelper.retrieveColumn('open_hours'),
          lodgingColumnHelper.retrieveColumn('chain_doors_cnt'),
        ],
      },
      ...(enableLodgingHotelAmenities
        ? [
            {
              title: 'Hotel Amenities',
              elements: HOTEL_AMENITIES.map((a) => [a.key, `Has ${a.label}`]),
            },
          ]
        : []),
      {
        title: 'Predicted Values and Deals',
        elements: getCommonChainProxyExportColumns(),
      },
    ]
  },
})
